import * as React from "react";

import { IJackpotType } from "../../../interfaces/index";

import { JackpotTypeEnum } from "../../../enums";

import starGold from "../../../assets/img/jackpot/star_gold.svg";
import starSilver from "../../../assets/img/jackpot/star_silver.svg";

const JackpotStars: React.FC<IJackpotType> = ({ type }) => (
  <>
    {type === JackpotTypeEnum.GOLD && (
      <div className="stars">
        <img src={starGold} alt="" />
        <img src={starGold} alt="" />
        <img src={starGold} alt="" />
        <img src={starGold} alt="" />
        <img src={starGold} alt="" />
      </div>
    )}
    {type === JackpotTypeEnum.SILVER && (
      <div className="stars">
        <img src={starSilver} alt="" />
        <img src={starSilver} alt="" />
        <img src={starSilver} alt="" />
      </div>
    )}
  </>
);

export default JackpotStars;
